import React from "react";
import styles from "./FixedButton.module.css";
import whatsapp from "../../asset/fixed/whatsappIcon.webp";
import { useContactDetails } from "../../contexts/contact-context";

const FixedButton = ({ bg }) => {
  const { whatsappNumber, whatsappText } = useContactDetails();
  return (
    <div
      onClick={() =>
        window.open(`https://wa.me/${whatsappNumber}?text=${whatsappText}`)
      }
      style={{ background: bg }}
      className={styles.fixed}
    >
      <img src={whatsapp} alt="whatsapp" />
    </div>
  );
};

export default FixedButton;
